import { T } from '@agos/shared'

import { retryLabel, unreachableNote } from './read-state'

/**
 * What a section draws in place of a list it could not load - FB-807, `FRONTEND.md` §9.528.
 *
 * **Per section, and that is the decision.** Escalating one failed coupons read to the screen's own
 * `data-profile-unreachable` would take away the order history, the addresses and the loyalty card that
 * all loaded correctly - a working screen replaced by a fault report. A card that silently renders
 * nothing is the other extreme and leaves the customer unable to tell *empty* from *broken*.
 *
 * The sentence and the button label live in `read-state.ts` beside the predicate, so the seven call
 * sites cannot drift into two wordings for one event.
 */
export function SectionUnreachable({
  section,
  onRetry,
}: {
  /** Names the section in the marker, so a test can say *which* card reported a fault. */
  section: string
  /** Refetches this query alone - the page's other reads are not touched. */
  onRetry: () => void
}) {
  return (
    <div
      className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground"
      data-section-unreachable={section}
    >
      <p>
        <T>{unreachableNote()}</T>
      </p>
      <button
        type="button"
        onClick={onRetry}
        data-section-retry={section}
        className="px-2.5 py-1 rounded-lg border border-border font-semibold text-foreground"
      >
        <T>{retryLabel()}</T>
      </button>
    </div>
  )
}
